var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullScreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5F896338-9171-4EB4-971E-9E3039843470@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Share_WIP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Post_processing_page_delivery",
    transform: "translate(-21.000000, -681.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fit_screen_black_24dp",
    transform: "translate(21.000000, 681.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,16 L18,16 L18,8 L6,8 L6,16 Z M8,10 L16,10 L16,14 L8,14 L8,10 Z M4,15 L2,15 L2,18 C2,19.1 2.9,20 4,20 L7,20 L7,18 L4,18 L4,15 Z M4,6 L7,6 L7,4 L4,4 C2.9,4 2,4.9 2,6 L2,9 L4,9 L4,6 Z M20,4 L17,4 L17,6 L20,6 L20,9 L22,9 L22,6 C22,4.9 21.1,4 20,4 Z M20,18 L17,18 L17,20 L20,20 C21.1,20 22,19.1 22,18 L22,15 L20,15 L20,18 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen);
export default __webpack_public_path__ + "static/media/full_screen.dd297708565b5bd64e2f245506743ce6.svg";
export { ForwardRef as ReactComponent };